import { ChangeDetectionStrategy, Component, SecurityContext, computed, inject, input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ParagraphComponentBase } from '@big-direkt/paragraphs-holder';
import { type HeadingModel } from '@big-direkt/utils/shared';

@Component({
    selector: 'big-paragraph-heading',
    template: '',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: 'container mb-0!',
        '[attr.id]': 'data().id', // eslint-disable-line @typescript-eslint/naming-convention
        '[innerHTML]': 'html()', // eslint-disable-line @typescript-eslint/naming-convention
    },
})
export class HeadingComponent extends ParagraphComponentBase<HeadingModel> {
    private readonly sanitizer = inject(DomSanitizer);

    public override readonly data = input.required<HeadingModel>();

    public readonly html = computed(() => {
        const level: string = this.sanitizer.sanitize(SecurityContext.HTML, this.data().level) ?? 'div';
        const levelClass: string = this.data().levelClass ? ` ${this.data().levelClass}` : '';
        const content: string = this.sanitizer.sanitize(SecurityContext.HTML, this.data().content) ?? '';
        const html = this.sanitizer.sanitize(SecurityContext.HTML, `<${level} class="overflow-hidden${levelClass}">${content}</${level}>`);

        return html;
    });
}
